import _slicedToArray from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import { useMemo } from 'react';
import { matchPath } from 'react-router-dom';

var matchRoute = function matchRoute(routes, pathname) {
  return _findInstanceProperty(routes).call(routes, function (route) {
    return matchPath(pathname, {
      path: route.path || undefined,
      exact: route.exact || undefined
    });
  });
};

export default function useRoutes(_ref) {
  var routes = _ref.routes,
      pathname = _ref.pathname,
      showNav = _ref.showNav;
  return useMemo(function () {
    var shouldRenderTop = showNav === 'top';
    var shouldRenderLeft = showNav === 'left';
    var shouldRenderTopAndLeft = showNav === 'split';
    var result = {};

    if (!routes) {
      return result;
    }

    if (shouldRenderTopAndLeft) {
      var topRoutes = _mapInstanceProperty(routes).call(routes, function (route) {
        return _objectSpread({}, route, {
          routes: undefined
        });
      });

      var activeTopRoute = matchRoute(routes, pathname);
      var sideRootPath = activeTopRoute === null || activeTopRoute === void 0 ? void 0 : activeTopRoute.path;
      var sideRoutes = activeTopRoute === null || activeTopRoute === void 0 ? void 0 : activeTopRoute.routes;

      if (!sideRoutes || !sideRootPath) {
        result = {
          topRoutes: topRoutes
        };
      } else {
        var _context;

        var activeSideRoute = matchRoute(sideRoutes, pathname);
        var subPath = activeSideRoute === null || activeSideRoute === void 0 ? void 0 : activeSideRoute.path;

        var tempRoutes = _objectSpread({}, topRoutes, _defineProperty({}, sideRootPath, subPath));

        _forEachInstanceProperty(_context = _Object$entries(tempRoutes)).call(_context, function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];

          var redirectRoute = _findInstanceProperty(routes).call(routes, function (route) {
            if (route && 'path' in route) {
              var path = route.path,
                  exact = route.exact;
              return path === key && exact;
            }

            return false;
          });

          if (redirectRoute) {
            redirectRoute.redirect = value;
          }
        });

        result = {
          topRoutes: topRoutes,
          sideRoutes: sideRoutes
        };
      }
    }

    if (shouldRenderTop) {
      result = {
        topRoutes: routes
      };
    }

    if (shouldRenderLeft) {
      result = {
        sideRoutes: routes
      };
    }

    return result;
  }, [routes, showNav, pathname]);
}